import { graphql, useRefetchableFragment } from 'react-relay';
import { useSurveyListFragmentQuery_surveysRef$key } from './__generated__/useSurveyListFragmentQuery_surveysRef.graphql';

const fragment = graphql`
  fragment useSurveyListFragmentQuery_surveysRef on Query
  @refetchable(queryName: "SurveyListRefetchQuery")
  @argumentDefinitions(input: { type: "FilteredSurveyInput!" }) {
    surveys(input: $input) {
      pageInfo {
        totalCount
      }
      edges {
        node {
          id
          tags
          status
          url
          ...useSurveyCardFragmentQuery_surveyRef
          ...useFinishedSurveyCardFragmentQuery_surveyRef
        }
      }
    }
    userData {
      firstName
    }
  }
`;

export function useSurveyListFragmentQuery(surveysRef: useSurveyListFragmentQuery_surveysRef$key) {
  return useRefetchableFragment(fragment, surveysRef);
}
